<template>
<div class="chapter">
<div class="inner_page">
<div id="Title">
<h1 class="book-title"><a id="page_6"></a><a id="page_7"></a><span class="bold">Braving the Workplace</span>
</h1>
<p class="book-title1">Belonging at the Breaking Point</p>
<p class="book-title2"><span class="bold">by Dr. Beth Kaplan, Ed.D.</span></p>
<div class="img_container2"><img alt="images" src="images/logo1.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?ae410782